/* eslint-disable react/destructuring-assignment */
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import Image from 'global/Image';
import { Input } from 'global/CustomInput/styled';

interface SectionPasswordField {
  onSubmit: () => void;
  preventSubmit?: boolean;
  submitText: string;
  inputPlaceHolder?: string;
  title: string;
  subTitle?: string;
  email: string;
  setEmail: (email: string) => void;
}

const SectionPasswordField = ({
  onSubmit,
  preventSubmit,
  submitText,
  inputPlaceHolder,
  title,
  subTitle,
  email,
  setEmail,
}: SectionPasswordField) => (
  <Flex height="455px" direction="column" justify="space-between">
    <div style={{ width: '100%', position: 'relative' }}>
      <Image
        src="/icon/password-email.svg"
        width="70px"
        height="70px"
        alt="lock"
        style={{ marginBottom: '18px' }}
      />
      <div style={{ paddingBottom: '18px' }}>
        <Text weight={700}>{title}</Text>
        {/* @ts-expect-error */}
        <Text color="#858585" pt="10px">
          {subTitle}
        </Text>
      </div>

      <Input
        type="text"
        autoFocus
        placeholder={inputPlaceHolder}
        value={email}
        onChange={(e) => setEmail(e.currentTarget.value)}
      />
    </div>

    <Button
      block
      type="primary"
      height="44px"
      radius="4px"
      onClick={onSubmit}
      disabled={preventSubmit}
    >
      <b>{submitText}</b>
    </Button>
  </Flex>
);

export default SectionPasswordField;
